import * as React from 'react';

export const FileXLSXIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="35"
    height="45"
    viewBox="0 0 35 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M29.0979 10.2604C27.9589 10.2593 26.8669 9.80634 26.0615 9.00096C25.2562 8.19557 24.8032 7.10355 24.8021 5.96456V0H5.60627C2.51003 0 1.60933e-05 2.51 1.60933e-05 5.60623V39.4021C0.00461092 42.4932 2.5151 45 5.60627 45H28.6479C29.3843 45.0003 30.7292 45 30.7292 45H32.5C33.47 45 34.2563 44.2144 34.2563 43.2444C34.2563 41.7705 34.2563 39.8362 34.2563 39.3938V10.2521L29.0979 10.2604Z"
        fill="#31C48D"
      />
    </g>
    <path
      d="M34.2566 10.2604H29.0982C27.9593 10.2593 26.8672 9.80634 26.0618 9.00096C25.2565 8.19557 24.8035 7.10355 24.8024 5.96456V0L34.2566 10.2604Z"
      fill="#31C48D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.68076 16.3881C8.68076 15.5444 9.36476 14.8604 10.2085 14.8604H23.9585C24.8023 14.8604 25.4863 15.5444 25.4863 16.3881V28.6104C25.4863 29.4541 24.8023 30.1381 23.9585 30.1381H10.2085C9.36477 30.1381 8.68076 29.4541 8.68076 28.6104V16.3881ZM10.2085 20.9715V24.027H13.2641V20.9715H10.2085ZM14.7919 20.9715V24.027H23.9585V20.9715H14.7919ZM23.9585 19.4437H10.2085V16.3881H23.9585V19.4437ZM23.9585 25.5548H14.7919V28.6104H23.9585V25.5548ZM13.2641 28.6104V25.5548H10.2085V28.6104H13.2641Z"
      fill="#31C48D"
    />
    <rect
      x="6.87561"
      y="33.203"
      width="20.8333"
      height="7.69383"
      rx="1.5625"
      fill="#31C48D"
    />
    <path
      d="M9.83335 39.1848C9.7021 39.1848 9.58941 39.1384 9.49528 39.0455C9.40248 38.9514 9.35608 38.8387 9.35608 38.7075C9.35608 38.5776 9.40248 38.4662 9.49528 38.3734C9.58941 38.2806 9.7021 38.2342 9.83335 38.2342C9.96062 38.2342 10.072 38.2806 10.1674 38.3734C10.2629 38.4662 10.3106 38.5776 10.3106 38.7075C10.3106 38.795 10.2881 38.8752 10.243 38.9481C10.1993 39.0197 10.1416 39.0774 10.07 39.1211C9.99841 39.1635 9.91953 39.1848 9.83335 39.1848Z"
      fill="white"
    />
    <path
      d="M11.8434 35.0603L12.6648 36.4484H12.6966L13.5219 35.0603H14.4943L13.2514 37.0967L14.5221 39.133H13.5318L12.6966 37.743H12.6648L11.8295 39.133H10.8432L12.1179 37.0967L10.867 35.0603H11.8434Z"
      fill="white"
    />
    <path
      d="M15.0532 39.133V35.0603H15.9143V38.4231H17.6603V39.133H15.0532Z"
      fill="white"
    />
    <path
      d="M20.4539 36.2316C20.438 36.0712 20.3697 35.9466 20.2491 35.8578C20.1284 35.7689 19.9647 35.7245 19.7579 35.7245C19.6173 35.7245 19.4987 35.7444 19.4019 35.7842C19.3051 35.8226 19.2309 35.8763 19.1792 35.9453C19.1288 36.0142 19.1036 36.0924 19.1036 36.1799C19.101 36.2528 19.1162 36.3165 19.1494 36.3708C19.1838 36.4252 19.2309 36.4723 19.2906 36.512C19.3502 36.5505 19.4191 36.5843 19.4974 36.6134C19.5756 36.6413 19.6591 36.6652 19.7479 36.685L20.1138 36.7725C20.2915 36.8123 20.4546 36.8653 20.6031 36.9316C20.7515 36.9979 20.8801 37.0794 20.9888 37.1762C21.0976 37.273 21.1817 37.387 21.2414 37.5183C21.3024 37.6495 21.3335 37.8 21.3349 37.9697C21.3335 38.2189 21.2699 38.435 21.144 38.618C21.0193 38.7996 20.839 38.9408 20.6031 39.0416C20.3684 39.141 20.0853 39.1907 19.7539 39.1907C19.4251 39.1907 19.1388 39.1403 18.8948 39.0396C18.6522 38.9388 18.4626 38.7897 18.3261 38.5921C18.1908 38.3933 18.1199 38.1473 18.1133 37.8544H18.9465C18.9558 37.9909 18.9949 38.1049 19.0638 38.1964C19.1341 38.2866 19.2276 38.3548 19.3442 38.4012C19.4622 38.4463 19.5955 38.4688 19.744 38.4688C19.8898 38.4688 20.0164 38.4476 20.1238 38.4052C20.2325 38.3628 20.3167 38.3038 20.3763 38.2282C20.436 38.1527 20.4658 38.0658 20.4658 37.9677C20.4658 37.8762 20.4387 37.7993 20.3843 37.737C20.3313 37.6747 20.2531 37.6217 20.1496 37.5779C20.0476 37.5342 19.9223 37.4944 19.7738 37.4586L19.3303 37.3473C18.987 37.2637 18.7158 37.1331 18.517 36.9555C18.3181 36.7778 18.2193 36.5385 18.2207 36.2376C18.2193 35.991 18.285 35.7756 18.4175 35.5913C18.5514 35.407 18.7351 35.2632 18.9684 35.1598C19.2017 35.0563 19.4669 35.0046 19.7638 35.0046C20.0661 35.0046 20.3299 35.0563 20.5553 35.1598C20.782 35.2632 20.9584 35.407 21.0843 35.5913C21.2102 35.7756 21.2752 35.989 21.2792 36.2316H20.4539Z"
      fill="white"
    />
    <path
      d="M22.7354 35.0603L23.5568 36.4484H23.5886L24.4139 35.0603H25.3863L24.1434 37.0967L25.4141 39.133H24.4238L23.5886 37.743H23.5568L22.7215 39.133H21.7352L23.0099 37.0967L21.759 35.0603H22.7354Z"
      fill="white"
    />
  </svg>
);

export default FileXLSXIcon;
